<template>
  <div>
    <h5>
      <strong>{{ $t("name") }}:</strong> {{ title }}
      <span class="ml-5" v-if="supervisor"
        ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <v-divider />
    <v-form ref="form">
      <v-row class="d-flex justify-center">
        <v-col cols="12" md="6">
          <v-combobox
            v-model="organizationSelected"
            :items="organizations"
            item-text="name"
            :label="$t('label.organization')"
            return-object
            outlined
            disabled
          ></v-combobox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="investigator.affiliation.start_date"
            :label="$t('label.startDate')"
            prepend-inner-icon="event"
            readonly
            outlined
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="investigator.affiliation.end_date"
            :label="$t('label.endDate')"
            prepend-inner-icon="event"
            readonly
            outlined
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-divider />
      <DirectorActions v-if="isAuthorize" :object_type="object_type" />
      <SupervisorActions
        v-else
        :item="investigator"
        :object_type="object_type"
        :form_name="form_name"
        :state="state"
        :supervisor="supervisor !== null ? supervisor.username : ''"
        @change-state-supervisor="onStateSupervisorChange"
      />
    </v-form>
  </div>
</template>

<script>
import axios from "axios";
import DirectorActions from "../../action_buttons/DirectorActions";
import SupervisorActions from "../../action_buttons/SupervisorActions";
import investigatorData from "../../../mixins/investigator_data";
import investigator_model from "../../../mixins/model_utils/investigator_model";

export default {
  mixins: [investigatorData, investigator_model],
  components: { DirectorActions, SupervisorActions },
  data: () => ({
    object_type: "investigator",
    form_name: "affiliationForm",
    state: "",
    title: "",
    supervisor: "",
    organizationSelected: ""
  }),

  created() {
    this.getOrganizations();
    this.getData();
  },

  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    }
  },

  methods: {
    getData() {
      let path;
      if (this.isAuthorize) {
        path =
          this.$store.state.endpoint +
          "/direction/moderatedOperations/authorize/investigator/" +
          this.$route.params.id;
      } else {
        path =
          this.$store.state.endpoint +
          "/moderatedOperations/review/investigator/" +
          this.$route.params.id;
      }
      axios
        .get(path)
        .then(response => {
          this.investigator.affiliation = response.data.data.user.affiliation;
          this.state = response.data.state;
          this.title = response.data.title;
          this.supervisor = response.data.supervisor;
          this.investigator.id = response.data.object_id;
          this.getInvestigatorName(
            this.$store.state.endpoint + "/person/" + this.investigator.id
          );
          this.loadOrganizationSelected(
            this.investigator.affiliation.organization
          );
        })
        .catch(error => {
          console.log(error);
        });
    },

    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    },
    loadOrganizationSelected(item) {
      this.organizationSelected = this.organizations.find(
        organization => organization.id === item
      );
    }
  }
};
</script>
